import EventsTable from 'components/EventsTable/EventsTable';
import withCountry from 'enhancers/withCountry';
import withEventsCsv, { IWithEventsCsvProps } from 'enhancers/withEventsCsv';
import withEventsCsvLinkQuery from 'enhancers/withEventsCsvLink';
import withEventsState, { WithEventsProps } from 'enhancers/withEventsState';
import * as React from 'react';
import styled from 'styled-components';

type Props = IWithEventsCsvProps & WithEventsProps;

export const Events: React.SFC<Props> = props => {
  const { events, loaded } = props.eventsData;

  if (loaded) {
    if (events) {
      if (props.events.filter === 'recent') {
        events.sort(
          (a, b) => parseInt(a.StartDate, 10) - parseInt(b.StartDate, 10)
        );
      }
      if (props.events.filter === 'oldest') {
        events.sort(
          (a, b) => parseInt(b.StartDate, 10) - parseInt(a.StartDate, 10)
        );
      }
    }

    return <Container>{events && <EventsTable events={events} />}</Container>;
  }
  return null;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  overflow-y: auto;
`;

export default withEventsState(
  withCountry(
    withEventsCsvLinkQuery(
      withEventsCsv({ withEventFilters: true, withCountryFilter: false })(
        Events
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/components/Events/Events.tsx